module.exports = __webpack_public_path__ + "static/media/SH_Block.e5147715.jpg";